/**
 * TicketKey — `APO-1284` mono chip. Never animates.
 */

type TicketKeyProps = {
  value: string;
  href?: string;
};

export function TicketKey({ value, href }: TicketKeyProps) {
  const inner = (
    <span
      style={{
        fontFamily: "var(--font-mono)",
        fontSize: 12,
        background: "var(--surface-2)",
        color: "var(--ink)",
        padding: "2px 6px",
        borderRadius: 3,
        letterSpacing: 0,
      }}
    >
      {value}
    </span>
  );
  if (!href) return inner;
  return (
    <a href={href} style={{ textDecoration: "none" }}>
      {inner}
    </a>
  );
}
